import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Paper, Grid, FormGroup, Typography, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import BaseMatManModal from '@monorepo/shared/src/components/common/Modals/BaseMatManModal';
import BaseModalTitle from '@monorepo/shared/src/components/common/Modals/BaseModalTitle';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { useModal } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Modal';
import useClassrooms from 'state/hooks/use-classrooms';
import useAssignments from 'state/hooks/use-assignments';
import EditAssignmentsHeader from './EditAssignmentsHeader';
import GroupDropdown from '../../Assignments/components/GroupDropdown';
import { getSortedGroups } from '../../Assignments/utils';
import { useRouteGuard } from 'state/hooks/use-route-guard';

const tAssignment = (key, options?) => translate('assignment', key, options);

const EditAssignmentContainer: React.FC = () => {
  const { letter } = useParams();
  const [{ activeClassroom }] = useClassrooms();
  const [{ assignments }, { handleExit, setSelectedGroupsAndStudents, setAllGroups, setLetter }] =
    useAssignments();
  const {
    isRouteGuardModalOpen,
    unblockRouter,
    handleContinueEditing: continueRouteGuard,
  } = useRouteGuard();
  const [, { openModal, closeModal }] = useModal();
  const classes = useStyles();

  const handleCancelAndClose = () => {
    unblockRouter();
    handleExit();
  };

  const displayRouteGuardModal = () => {
    openModal({
      Title: () => <BaseModalTitle text={tAssignment('unsavedChanges')} onClose={closeModal} />,
      body: (
        <BaseMatManModal
          leftButtonAction={handleCancelAndClose}
          rightButtonAction={continueRouteGuard}
          headerText={tAssignment('unsavedChangesHeader')}
          headerFontSize={'24px'}
          leftButtonText={tAssignment('cancelAndClose')}
          rightButtonText={tAssignment('backToEditing')}
        >
          <Box>
            <Typography variant="subtitle1">{tAssignment('unsavedChangesBodyEdit')}</Typography>
          </Box>
        </BaseMatManModal>
      ),
    });
  };

  useEffect(() => {
    if (activeClassroom?.groups?.length) {
      setAllGroups(activeClassroom?.groups);
    }
  }, [activeClassroom]);

  useEffect(() => {
    setSelectedGroupsAndStudents();
  }, [assignments]);

  useEffect(() => {
    if (isRouteGuardModalOpen) {
      displayRouteGuardModal();
    }
  }, [isRouteGuardModalOpen]);

  useEffect(() => {
    if (letter) setLetter(letter);
  }, [letter]);

  const renderGroups = () => {
    if (!activeClassroom?.groups) return;
    const sortedGroups = getSortedGroups(activeClassroom?.groups);
    return sortedGroups?.map((group) => <GroupDropdown key={group.id} group={group} />);
  };

  return (
    <Paper className={classes.container}>
      <Grid container spacing={0} alignItems="center" justifyContent="center">
        <Grid item xs={10}>
          <EditAssignmentsHeader name={activeClassroom?.name} />
        </Grid>
        <Grid item xs={10}>
          <FormGroup>{renderGroups()}</FormGroup>
        </Grid>
      </Grid>
    </Paper>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    width: '80%',
    margin: 'auto',
    paddingBottom: 60,
    marginTop: 30,
    justifyContent: 'space-evenly',
  },
}));

export default EditAssignmentContainer;
